import React from 'react';
import './MaintenancePage.css';

const MaintenancePage: React.FC = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-box">
        <img src="/HRO-Logo-transparent.png" alt="Horse Racing Oracle Logo" className="maintenance-logo" />

        <h1 className="maintenance-title">System Maintenance</h1>
        <p className="maintenance-subtitle">
          Horse Racing Oracle is up and running. There are no issues to report.</p>
      </div>
    </div>
  );
};

export default MaintenancePage; 